import { useEffect } from "react";
import { useHistory } from "react-router";

export function useLogHistoryChanges() {
    const history = useHistory();

    useEffect(() => {
        const isDev = process.env.NODE_ENV && process.env.NODE_ENV === "development";
        const log = isDev ? console.log : console.debug;
        return history.listen((location, action) =>
            log("Navigation:", action, location.pathname, location),
        );
    }, [history]);
}
